import {mapGetters, mapState} from "vuex";
import Enums from "../model/enums";
import {
  SKIP_YEAR_TAX_FORMS,
  SET_TAX_FORM_DATA,
  SAVE_SE_REQUEST,
  CREATE_CASEFILE_ASSOCIATION
} from "../store/actions/se";
import baseFormMixin from "./BaseFormMixin";
export const taxSingleFormMixin = {
  mixins: [baseFormMixin],
  data() {
    return {
    }
  },
  validations() {
    return {
      tableData: (this.tableData || []).map(() => ({
        checkHasAnswer: (row) => this.checkHasAnswer(row),
        checkRequired: (row) => this.checkRequired(row)
      })),
      allAnswered: {
        answered: (v) => v
      }
    }
  },
  created() {
    this.Enums = Enums
    this.init(this.$route.params.year, this.$route.params.formName, this.$route.params.idx);
  },

  // Vue Router 4 reads navigation guards from the RAW component definition
  // (rawComponent.__vccOpts || rawComponent), not from mixin-merged $options.
  // beforeRouteUpdate defined in a mixin is therefore never called.
  // Use a $route watcher instead — it is part of Vue's Options API and IS
  // properly merged from mixins, so it reliably fires when the router reuses
  // the same component with different params (e.g. switching tax year).
  watch: {
    '$route'(to, from) {
      // Only re-init when navigating within the same named route (same
      // component instance reused, different params such as year/formName).
      // Navigating away to a different form has a different route name.
      if (to.name === from.name) {
        this.init(to.params.year, to.params.formName, to.params.idx);
      }
    }
  },
  computed: {
    allAnswered() {
      return this.skippedForm
        || this.isLocked
        || !this.tableData.some((f, index) => f.required !== false && !f.value && !f.isEmpty && !this.isSkipped[index])
    },
    isEmpty() {
      return this.tableData.map(f => f.isEmpty);
    },
    pdfViewerKey() {
      return this.taxFormYear + this.taxFormId
    },
    isSkipFormBtnDisplayed() {
      return ([Enums.SeBusinessStructureType.llc, Enums.SeBusinessStructureType.unknown].includes(this.$store.getters.getBusinessStructureProvided))
        && (this.getPY2 === this.taxFormYear) && !this.skippedForm
    },
    isUnSkipFormBtnDisplayed() {
      return (this.getPY2 === this.taxFormYear) && this.skippedForm
    },
  },


  methods: {
    init(year, formName, idx) {
      this.taxFormYear = year;
      this.taxFormId = formName;
      this.taxFormIdx = parseInt(idx, 10) || 0

      const form = this.seConf.taxYears.filter(ty => ty.year === this.taxFormYear)
        .flatMap(rtn => rtn.forms)
        .flatMap(form => form.forms)
        .find(f => f.id === this.taxFormId);

      this.seFields = form.fields
      this.pdf = form.pdf
      this.tableData = []
      this.skippedForm = false

      let storedDataArray = this.seRequest.taxData.filter(f => f.year === this.taxFormYear && f.formId === this.taxFormId);
      let storedData = (storedDataArray?.length > this.taxFormIdx) ? storedDataArray[this.taxFormIdx] : null;

      if (storedData) {
        this.skippedForm = storedData.skipped
        if (storedData.fields) {
          storedData = storedData.fields;
        }
      }

      //initial fill
      this.seFields.forEach(f => {

        let existingRow = this.tableData.find(td => td.id === f.id)
        if (existingRow) {
          existingRow.fieldHighlights.push(f.fieldName)
        }
        else if (!existingRow && !f.staticText) {
          let row = {
            id: f.id,
            line: f.line,
            name: f.label,
            value: f.defaultValue ? f.defaultValue: '',
            isEmpty: this.isEmptyByDefault(f),
            fieldName: f.fieldName,
            required: f.required,
            isCurrency: f.isCurrency,
            isPositive: f.isPositive,
            isBoolean: f.isBoolean,
            isInteger: f.isInteger,
            hasHelp: f.hasHelp,
            showHelp: false,
            fieldHighlights: f.fieldHighlights ? f.fieldHighlights : [f.fieldName],
            mask: this.getFieldMask(f),
            pageHeader: f.pageHeader,
            defaultValue: f.defaultValue,
            description: f.description,
            persistSkippedValue: f.persistSkippedValue
          };

          if (f.hasHelp) {
            this.showFieldHelp[f.id] = false
          }

          if (storedData) {
            let storedField = storedData.find(sf => sf.id === f.id);
            if (storedField) {
              if (storedField.isEmpty) {
                row.isEmpty = this.getPreparedStoredDataForIsEmpty(storedField.isEmpty, row);
              } else if (storedField.value) {
                row.isEmpty = false;
                row.value = this.getPreparedStoredData(storedField.value, row);
              }
            }
          }
          this.tableData.push(row);
        }
      })
      this.setFieldFocus(true)
    },
    isEmptyByDefault(field) {
      return field.isEmptyByDefault ? field.isEmptyByDefault : false;
    }
  }

}
